export default __webpack_public_path__ + "static/media/gpc-location.32ba48fa.svg";